module.exports = __webpack_public_path__ + "img/users-x.b00d81e9.svg";